import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { BiData } from '@wix/da-bi/pkg/events';
import { ReferralType, BiEventType } from '@wix/da-bi/pkg/constants';
import StandardMenu from '../../../../Dropdown/MenuPreset/StandardMenu';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import { useDeviationAttributes } from '../../../../DeviationViews/hooks/useDeviationAttributes';
import { useRestrictToLoggedIn } from '../../../../utils/hooks/useRestrictToLoggedIn';
import s from './MoreMenuContent.scss';
// This is used only on desktop
const MoreMenuContent = ({ deviation , isOwner , closeTooltip =()=>null , showReportModal , showDesktopDeviationSharePopup , showNftLinkPopup , shareDeviationToPost  })=>{
    const kill_prints_act_two = useFlag('kill_prints_act_two');
    const { t  } = useTranslation();
    const { restrictToLoggedIn  } = useRestrictToLoggedIn();
    const { isPrintPurchasable , isShareable , isReportable , hasNft  } = useDeviationAttributes(deviation, isOwner);
    const { print: { lowestPrice , purchaseUrl  } = {}  } = deviation;
    const isIncludingPrintPurchase = isPrintPurchasable && !!purchaseUrl && !kill_prints_act_two;
    const printLinkLabel = lowestPrice ? t('actionbar.buyPrintsFor', {
        price: lowestPrice
    }) : t('actionbar.buyPrints');
    return /*#__PURE__*/ React.createElement(StandardMenu, {
        className: s['menu'],
        id: "actionbar-more-menu",
        items: [
            isShareable && {
                value: 'share',
                label: t('actionbar.share'),
                biData: BiData({
                    evid: 355,
                    typeid: getDeviationResourceType(deviation),
                    itemid: deviation.deviationId,
                    deviationid: deviation.deviationId
                }),
                onClick: showDesktopDeviationSharePopup
            },
            isShareable && {
                value: 'shareToPost',
                label: t('actionbar.shareToPost'),
                onClick: restrictToLoggedIn(ReferralType.SHARE_TO_POST, ()=>shareDeviationToPost(deviation)),
                biData: BiData({
                    evid: 356,
                    typeid: getDeviationResourceType(deviation),
                    itemid: deviation.deviationId,
                    social_share: 'da_post',
                    deviationid: deviation.deviationId
                })
            },
            isIncludingPrintPurchase && {
                value: 'printPurchase',
                label: printLinkLabel,
                biData: {
                    evid: BiEventType.BUY_CLICK,
                    deviationid: deviation.deviationId
                },
                link: purchaseUrl
            },
            isReportable && {
                value: 'report',
                label: t('actionbar.report'),
                biData: BiData({
                    evid: 20,
                    modal_version: 2,
                    deviationid: deviation.deviationId
                }),
                onClick: ()=>{
                    showReportModal(deviation);
                    closeTooltip();
                }
            },
            !hasNft && isOwner && {
                value: 'linknft',
                label: t('actionbar.linkNft'),
                onClick: ()=>{
                    showNftLinkPopup(deviation);
                    closeTooltip();
                }
            }
        ]
    });
};
MoreMenuContent.displayName = 'MoreMenuContent';
export default MoreMenuContent;
